import { render, staticRenderFns } from "./WorkerReport.vue?vue&type=template&id=76565afe&"
import script from "./WorkerReport.vue?vue&type=script&lang=js&"
export * from "./WorkerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WorkerReport.vue"
export default component.exports